import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { FunnelOverview } from '@/components/dashboard/funnel-overview'

export const DashboardPage = () => {
  return (
    <div
      className="mx-auto w-full max-w-[1600px] space-y-6"
      data-testid="admin-dashboard"
    >
      <DashboardHeader />
      <FunnelOverview />
      {/* TODO: Bring in onboarding health when backend is implemented (issue-3329 branch) */}
    </div>
  )
}
